import {
  CloudOutlined,
  ExperimentOutlined,
  HeartOutlined,
  InfoCircleOutlined,
  MedicineBoxOutlined,
  ReadOutlined,
  SafetyOutlined,
  SmileOutlined,
  SunOutlined,
  SyncOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import Ribbon from 'assets/ribbon.svg?react';
import { CSSProperties } from 'react';

/**
 * The icon of a category: an image uploaded in the admin (SVG) when there is
 * one, else the icon the backend's short key names (set in the admin), else
 * nothing. An unknown key falls back to a book so a typo never breaks a
 * page. Both are sized like an antd icon (1em square).
 */
const ICONS: Record<string, React.ComponentType<{ className?: string; style?: CSSProperties }>> = {
  info: InfoCircleOutlined,
  book: ReadOutlined,
  cycle: SyncOutlined,
  pair: TeamOutlined,
  heart: HeartOutlined,
  sun: SunOutlined,
  lotus: SmileOutlined,
  drop: ExperimentOutlined,
  leaf: MedicineBoxOutlined,
  ribbon: Ribbon,
  shield: SafetyOutlined,
  cloud: CloudOutlined,
};

export default function CategoryIcon({
  icon,
  iconUrl,
  className,
  style,
}: {
  icon: string;
  iconUrl?: string | null;
  className?: string;
  style?: CSSProperties;
}) {
  if (!iconUrl && !icon) return null;
  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt=""
        className={className}
        style={{ width: '1em', height: '1em', objectFit: 'contain', ...style }}
        data-testid="category-icon-image"
      />
    );
  }
  const Icon = ICONS[icon] ?? ReadOutlined;
  // The ribbon is a raw SVG: size it like an antd icon (1em square)
  const sizing = Icon === Ribbon ? { width: '1em', height: '1em', ...style } : style;
  return <Icon className={className} style={sizing} aria-hidden />;
}
